/**
 * Shared vocabulary for web mentions. Kept in one place because the summary widget and the
 * mentions page previously disagreed about the API's field names — the widget read
 * `totalMentions`/`averageSentiment` while the API returns `count`/`avgSentiment`, so it silently
 * showed zero mentions forever.
 *
 * Backend enums serialize camelCase (ConditionalJsonStringEnumConverter), so compare against
 * camelCase strings, never numbers.
 */

export function sentimentColor(score) {
  if (score == null) return "gray";
  if (score > 0.3) return "green";
  if (score > 0.05) return "lime";
  if (score > -0.05) return "gray";
  if (score > -0.3) return "yellow";
  return "red";
}

export function sentimentLabel(score) {
  if (score == null) return "Pending";
  if (score > 0.3) return "Positive";
  if (score > 0.05) return "Slightly positive";
  if (score > -0.05) return "Neutral";
  if (score > -0.3) return "Slightly negative";
  return "Negative";
}

export const ACTION_LABELS = {
  none: "No action",
  respondPublicly: "Respond publicly",
  correctFactualError: "Correct an error",
  createContent: "Create content",
  reviewManually: "Review manually",
};

export const ACTION_COLORS = {
  none: "gray",
  respondPublicly: "orange",
  correctFactualError: "red",
  createContent: "blue",
  reviewManually: "grape",
};

export const KIND_LABELS = {
  unknown: "Other",
  news: "News",
  review: "Review",
  forum: "Forum",
  comparison: "Comparison",
  listicle: "Listicle",
  blog: "Blog",
  documentation: "Docs",
  jobPosting: "Job posting",
  pressRelease: "Press release",
  marketplace: "Marketplace",
};

export const STATUS_LABELS = {
  new: "New",
  actioned: "Actioned",
  dismissed: "Dismissed",
};

export function actionLabel(action) {
  return ACTION_LABELS[action] ?? "No action";
}

export function actionColor(action) {
  return ACTION_COLORS[action] ?? "gray";
}

export function kindLabel(kind) {
  return KIND_LABELS[kind] ?? "Other";
}

export function needsAction(mention) {
  return mention.suggestedAction && mention.suggestedAction !== "none";
}
